import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assest/Om-01.png";

const QuizBanner = () => {
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleStartExam = () => {
    navigate("/assessment");
  };

  return (
    <div style={styles.fullWidthBackground}>
      <div style={styles.container}>
        <img
          src={logo}
          alt="Logo"
          style={{
            ...styles.logo,
            width: isMobile ? "280px" : "600px",
            marginTop: isMobile ? "0" : "-60px",
            marginBottom: isMobile ? "10px" : "-20px",
          }}
        />
       <h2 style={{
           fontSize: isMobile ? "1.5rem" : "2rem",
           fontWeight: "bold",
           textAlign: "center",
           marginTop: isMobile ? "0px" : "0px",
           marginBottom: isMobile ? "20px" : "40px",
           color: "#fff",
          }}>
          TOPIC: CODE OF CONDUCT 
        </h2>

        <div
          style={{
            ...styles.flexRow,
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "center" : "flex-start",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          {/* Left: Video */}
          <div style={{ ...styles.left, width: isMobile ? "100%" : "50%" }}>
            <div style={styles.videoInner}>
              <iframe
                style={styles.iframe}
                src="https://www.youtube.com/embed/LJWEyLvCgNE?si=pV6r8O0GlKFe-aD0"
                title="Quiz Intro"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          {/* Right: Info boxes + button */}
          <div style={{ ...styles.right, width: isMobile ? "100%" : "48%" }}>
            <div
              style={{
                ...styles.infoGrid,
                gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
              }}
            >
              <div style={styles.infoBox}>
                <span style={styles.icon}>📅</span>
                <div>
                  <div style={styles.label}>Date</div>
                  <div style={styles.value}>
                     August-2025 
                  </div>
                </div>
              </div>

              <div style={styles.infoBox}>
                <span style={styles.icon}>⏰</span>
                <div>
                  <div style={styles.label}>Time</div>
                  <div style={styles.value}>15 Min</div>
                </div>
              </div>

              <div style={styles.infoBox}>
                <span style={styles.icon}>🎥</span>
                <div>
                  <div style={styles.label}>Venue</div>
                  <div style={styles.value}>Online</div>
                </div>
              </div>

              <div style={styles.infoBox}>
                <span style={styles.icon}>🌐</span>
                <div>
                  <div style={styles.label}>Language</div>
                  <div style={styles.value}>Marathi</div>
                </div>
              </div>
            </div>

            <button
              style={{
                ...styles.button,
                fontSize: isMobile ? "1.2rem" : "1.5rem",
                padding: isMobile ? "16px" : "20px",
              }}
              onClick={handleStartExam}
            >
              I Am Ready for Exam
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  fullWidthBackground: {
    width: "100%",
    backgroundColor: "#14121c",
    minHeight: "95vh",
    padding: "14px 0px",
    fontFamily: "Arial, sans-serif",
    color: "#fff",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    textAlign: "center",
    padding: "0 16px",
  },
  logo: {
    display: "block",
    margin: "0 auto",
  },
  flexRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "40px",
    marginTop: "20px",
  },
  left: {
    maxWidth: "600px",
  },
  right: {
    maxWidth: "100%",
  },
  videoInner: {
    position: "relative",
    width: "100%",
    paddingBottom: "56.25%",
    height: 0,
    overflow: "hidden",
    borderRadius: "10px",
  },
  iframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: "none",
  },
  infoGrid: {
    display: "grid",
    gap: "20px",
    marginBottom: "30px",
    marginTop: "6%",
  },
  infoBox: {
    backgroundColor: "#0b0b13",
    borderRadius: "18px",
    padding: "16px",
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    border: "1px solid #2a2a40",
  },
  icon: {
    fontSize: "24px",
    color: "#f4b006",
  },
  label: {
    fontSize: "0.9rem",
    color: "#aaa",
  },
  value: {
    fontSize: "1.1rem",
    fontWeight: "bold",
    color: "#fff",
  },
  button: {
    width: "100%",
    backgroundColor: "#174f0c",
    color: "#fff",
    fontWeight: "bold",
    border: "none",
    borderRadius: "16px",
    cursor: "pointer",
    marginTop: "10px",
  },
};

export default QuizBanner;
